import { FeatureFlagOverride } from "generated-graphql/graphql";

type WasteProgramEnablementInput = {
  wasteFeatureFlagOverride: FeatureFlagOverride | null | undefined;
  isTenantWasteModuleEnabled: boolean;
};

export function isWasteProgramEffectivelyEnabled({
  wasteFeatureFlagOverride,
  isTenantWasteModuleEnabled,
}: WasteProgramEnablementInput): boolean {
  if (wasteFeatureFlagOverride === FeatureFlagOverride.Enabled) return true;
  if (wasteFeatureFlagOverride === FeatureFlagOverride.Inherit) return isTenantWasteModuleEnabled;
  return false;
}
